module.exports = __webpack_public_path__ + "static/media/2-option4-4row.95058496.png";